import { render } from "./FormRfqVendor.vue?vue&type=template&id=bfb46056&scoped=true"
import script from "./FormRfqVendor.vue?vue&type=script&lang=js"
export * from "./FormRfqVendor.vue?vue&type=script&lang=js"

import "./FormRfqVendor.vue?vue&type=style&index=0&id=bfb46056&scoped=true&lang=css"
import "./FormRfqVendor.vue?vue&type=style&index=1&id=bfb46056&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfb46056"]])

export default __exports__